<template>
  <div class="book-select">
    <Form inline :label-width="70">
      <FormItem class="first" label="图书分类" v-if="showCatagory">
        <Cascader :data="classifyList" v-model="selectClassify" clearable></Cascader>
      </FormItem>
      <Form-item label="图书名称">
        <Input
          style="width:200px"
          placeholder="请输入图书名称关键字"
          @on-search="onSearch"
          v-model="searchCondition.name"
          @keydown.native.prevent.enter="onSearch"
          clearable
        />
      </Form-item>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        method="get"
        :columns="columns"
        data-url="/api/books"
        :search="searchCondition"
        :rowsFormatter="onFormatter"
        @onSelectionChange="onSelectionChange"
        :selectType="selectType"
        keyField="id"
        :selectedItems="selectedItems"
        keepSelected
      >
        <template slot="footer-left">
          <Button
            icon="ios-refresh"
            class="btn-margin-right"
            type="text"
            @click="onSearch"
            style="margin-left:5px;"
          >刷新</Button>
        </template>
      </Grid>
    </div>
  </div>
</template>

<script>
import { BookStatus } from "@/utils/enums";
export default {
  name: "book-select",
  props: {
    selectType: {
      type: String,
      default: "multi"
    },
    selectedItems: {
      type: Array
    },
    showCatagory: {
      type: Boolean,
      default: false
    },
    showStatus: {
      type: Boolean,
      default: true
    },
    status: {
      type: Number,
      default: 1
    },
    spellGroup: {
      type: Number,
      default: 0
    },
    showPrice: {
      type: Boolean,
      default: false
    },
    integralShop: {
      type: Number,
      default: 0
    },
    recommend: {
      default: 0
    },
    approval_status: {
      default: 1
    },
    showStock: {
      default: 0
    }
  },
  data() {
    return {
      searchCondition: {
        name: "",
        book_classify_id: "",
        status: this.status,
        spell_group: this.spellGroup,
        integral_shop: this.integralShop,
        recommend: this.recommend,
        status: this.approval_status,
        init() {
          this.name = "";
          this.book_classify_id = "";
        }
      },
      classifyList: [],
      selectClassify: [],
      columns: [{ title: "图书名称", key: "name" }],
      selectList: []
    };
  },
  async created() {
    if (this.showPrice) {
      this.columns.push({ title: "价格", key: "price_str" });
    }
    if (this.showCatagory) {
      this.columns.push({ title: "图书分类", key: "book_classify" });
      await this.getClassify();
    }
    if (this.showStatus) {
      this.columns.push({
        title: "上架状态",
        key: "statusName",
        width: 120,
        align: "center"
      });
    }

    if (this.showStock) {
      this.columns.push({
        title: "库存",
        key: "stock",
        align: "center"
      });
    }
  },
  methods: {
    async getClassify() {
      let list = await this.$http.get("/api/course/classify");
      let classifyList = [];
      list.forEach(c => {
        let classify = { value: c.id, label: c.name, children: [] };
        if (c.children) {
          c.children.forEach(child => {
            classify.children.push({ value: child.id, label: child.name });
          });
        }
        classifyList.push(classify);
      });
      this.classifyList = classifyList;
    },
    onSearch() {
      if (this.selectClassify.length > 0) {
        this.searchCondition.book_classify_id = this.selectClassify[
          this.selectClassify.length - 1
        ];
      } else {
        this.searchCondition.book_classify_id = "";
      }
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.selectClassify = [];
      this.onSearch();
    },
    onFormatter(rows) {
      rows.forEach(i => {
        i.statusName = BookStatus.getValue(i.status);
        i.price_str = "¥" + i.price / 100;
      });
    },
    onSelectionChange(val) {
      this.selectList = [...val];
      this.$emit("onSelectionChange", this.selectList);
    },
    getSelectList() {
      return this.selectList;
    },
    recoverSelectedItems(selectedItems) {
      this.$refs.grid.recoverSelectedItems(selectedItems);
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
